import React from "react";

const PanelSegmentPagination = (props: React.PropsWithChildren<unknown>) => {
  return <div className="panel-segment-pagination">
    {props.children}
  </div>;
};

export default PanelSegmentPagination;
